import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { FetchPolicy } from '@apollo/client/core/watchQueryOptions';
import type { OperatorsQueryInput } from '@/models/operator';

export const fetchOperators = async (variables: OperatorsQueryInput, fetchPolicy: FetchPolicy = 'cache-first') => {
  const response = await queryExecute({
    variables,
    fetchPolicy,
    query: graphql(`
      query Operators(
        $pagination: PaginationInputType
        $query: String
        $isActive: Boolean
        $roles: [String!]
        $isIncludeTeamLead: Boolean
        $isNoAssignedTL: Boolean
        $isRehireEligible: Boolean
        $deactivatedStartDate: String
        $deactivatedEndDate: String
        $languages: [String!]
      ) {
        operators(
          pagination: $pagination
          query: $query
          isActive: $isActive
          roles: $roles
          isIncludeTeamLead: $isIncludeTeamLead
          isNoAssignedTL: $isNoAssignedTL
          isRehireEligible: $isRehireEligible
          deactivatedStartDate: $deactivatedStartDate
          deactivatedEndDate: $deactivatedEndDate
          languages: $languages
        ) {
          count
          rows {
            id
            firstName
            lastName
            email
            phoneNumber
            textNumber
            language1
            language2
            workerSid
            departments
            registrationCallPriorities {
              registrationCallType
              priority
            }
            registrationCallPriorityOverride
            slackId
            slackWebHook
            slackAlertWebHook
            defaultType
            isDefaultOnly
            closedAt
            slingUserId
            teamLeadId
            deactivationReason
            suspendReason
            contactUri
            teamLead {
              firstName
              lastName
            }
            isRehireEligible
            suspendedAt
            isSuspended
            isRecordAllCalls
            isEnableRegFlowView
            regCallAudio
            resignationReason
            isVerified
          }
        }
      }
    `),
  });

  return response.data.operators;
};
